export const messages = {
  title: 'Accounts Visibility Settings',
  subtitle: `You have marked this account as primary, 
  but you are also associated with the accounts listed below. 
  Checked accounts below will be hidden from being discovered by new brands. 
  Unchecked accounts will be visible to new brands.
  It may take 30 minutes for any changes to take effect.`,
  headingContent: 'Hide accounts from being discovered:',
  saveButton: 'Save',
  allAccounts: 'All Accounts',
  errorTitle: 'Account Settings Not Updated',
  errorDescription: 'There was an error hiding your selected accounts.',
  successTitle: 'Account Settings Updated',
  successDescription:
    'Your selected accounts have been hidden from being found by new brands.' +
    ' It may take 30 minutes for this change to take effect.',
}
